/** Created by azhou on 2019/3/22.*/
<template>
  <div>
    <public-title>已付款</public-title>
    <div class="bg-white load-area">
      <div class="d-center-between flex-wrap">
        <left-text-border class="w-45 mb-3" leftText="订单号"  v-model="searchData.oid" @enter="confirmSearch"/>
        <left-text-border class="w-45 mb-3" leftText="回单号"  v-model="searchData.receipt_no" @enter="confirmSearch"/>
        <left-text-select class="w-45 mb-3" leftText="门店类型" :options="$GVAR.StoreTypeGro " v-model="searchData.store_type" />
        <left-text-autocomplete  class="w-45 mb-3" leftText="门店名称" v-model="searchData.title"  @enter="confirmSearch" :storeType="3"/>
        <left-text-border class="w-45 mb-3" leftText="银行账户" v-model="searchData.truename" @enter="confirmSearch"/>
        <left-text-border class="w-45 mb-3" leftText="银行卡号" v-model="searchData.channel_refund_no" @enter="confirmSearch"/>
        <left-text-border class="w-45 mb-3" leftText="打款ID" v-model="searchData.pay_id" @enter="confirmSearch"/>
        <div class="w-45 mb-3 d-center-start" >
          <el-select v-model="timeType" placeholder="时间查询" size="small" class="mr-1" style="width:260px;">
            <el-option v-for="item in timeChoose" :key="item.value" :label="item.name" :value="item.value" />
          </el-select>
          <el-date-picker 
              v-model="timestamp" type="daterange" class="w-100" size="small"
              v-show="$GFUN.isInArray(['timeFrame','postTime','dealTime'],timeType)"
              range-separator="至" 
              value-format="timestamp" 
              start-placeholder="开始时间"
              end-placeholder="结束时间" 
            />
          <el-date-picker type="date" 
              v-model="timetime" 
              class="w-100" 
              size="small" 
              v-show="timeType === 'timeArr'" 
              placeholder="可选择一个日期"
              />
        </div>
      </div>
      <div class="d-center-between mb-3">
            <div class="text-left ml-2 text-blue totals">
              <p>统计:</p>
              <p>平台收款：{{AdminDataLists.info.total.price_pay_total /100 | formatMoney}} 元</p>
              <p>手续费：{{AdminDataLists.info.total.app_charge_total /100 | formatMoney}} 元</p>
              <p>付自由行：{{AdminDataLists.info.total.offset_price_pay_total /100 | formatMoney}} 元</p>
              <p>订单金额：{{AdminDataLists.info.total.payment_pay_total /100 | formatMoney}} 元</p>
              <p>酒店佣金：{{AdminDataLists.info.total.charge_total /100 | formatMoney}} 元</p>
              <p>实际已付款金额：{{AdminDataLists.info.total.fact_payment_pay_total /100 | formatMoney}} 元</p>
            </div>
            <el-button type="success" size="small" @click="loadTable" class="loadTable">下载表单</el-button>
            <el-button type="primary" size="small" @click="confirmSearch">搜索</el-button>
      </div>
      <p v-if="AdminDataLists.total<=0" class="mt-3">当前没有数据</p>
      <div v-else class="el-tables">
       <template>
          <el-table
            :data="AdminDataLists.lists"
            :summary-method="getSummaries"
             show-summary
            border
            stripe
            max-height="780"
            style="width: 100%">
            <!--表单内容-->
            <el-table-column v-for="(item,index) in fundsForm" :key="index" :prop="item.prop" :label="item.name" :width="item.width" :min-width="item.minWidth" header-align="center">
              <!-- 自定义表头 -->
              <template slot="header" slot-scope="scope">
                <span>{{ scope.column.label }}</span>
              </template>
              <template slot-scope="scope">
                <!--订单号-->
                <div class="cursor-pointer pointers" :class="{'text-center':item.center}" v-if="item.pattern==='oid'" @click="goHotelDetail(scope.row)">{{ scope.row[item.prop]}}</div>
                <!--时间-->
                <div :class="{'text-center':item.center}" v-else-if="item.pattern==='time'">{{ scope.row[item.prop]| formatTimestamp(1)}}</div>
                <!--金额-->
                <div :class="{'text-center':item.center}" v-else-if="item.pattern==='money'">{{ scope.row[item.prop]/100 | formatMoney}}<div class="price_pay" v-if="item.prop=='price_pay'&&scope.row.broker==1">(代订收款)</div></div>
                <!--状态-->
                <div class="text-green" :class="{'text-center':item.center}" v-else-if="item.pattern==='status'">{{ scope.row[item.prop]| formatVar('orderstatus')}}</div>
                <!--门店类型-->
                <div :class="{'text-center':item.center}" v-else-if="item.pattern==='type'">{{ scope.row[item.prop]| formatVar('StoreTypeGro')}}</div>  
                <!--其他-->
                <div :class="{'text-center':item.center}" v-else>{{ scope.row[item.prop]}}</div>
              </template>
            </el-table-column>
            <!--操作按钮-->
            <el-table-column
              fixed="right"
              header-align="center"
              label="操作"
              width="100">
              <template slot-scope="scope">
                <el-dropdown @command="handleCommand($event,scope.row)">
                    <el-button  type="text" size="small" style="margin: 0 auto; display: block   ;">查看<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item  command="1" >详情</el-dropdown-item>
                    <el-dropdown-item  command="2" >查看回单</el-dropdown-item>
                    <el-dropdown-item  command="2" v-if="scope.row.edit_time<0">查看回单</el-dropdown-item>
                    <el-dropdown-item  command="3"  v-if="userLoginMessage.id==scope.row.submit_uid">修改信息</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="prev, pager, next, sizes" class="mt-4" :page-sizes="[10,15,20,30]" :page-size="Formdata.num" @size-change="handleSizeChange"
                       :total="AdminDataLists.total" :current-page="Number(Formdata.page)" @current-change="handleCurrentChange"/>
        </template>
      </div>
    </div>
    <el-dialog title="打款回单" :visible.sync="dialogFormVisible" width="1400px" class="paymentist" >
        <Receipt :receiptInfo="receiptInfo"></Receipt>
    </el-dialog>
    <el-dialog title="打款详情" :visible.sync="dialogDLiest" width="40%" class="paymentist" >
      <div class="d-flex flex-wrap">
        <div class=" w-50 mb-3" v-for="item in showDetailArr" :key="item.name">
          <div class="w-100 d-center-start" v-if="item.value=='payment_pay'||item.value=='charge'||item.value=='fact_payment_pay'">
            <left-text :leftText="item.name" /><span :class="item.color?item.color:''">{{currentItem[item.value]/100| formatMoney}}元</span>
          </div>
          <div class="w-100 d-center-start" v-if="item.value==='store_type'">
             <left-text :leftText="item.name"/><span >{{currentItem[item.value]| formatVar('StoreTypeGro')}}</span>
          </div>
          <div class="w-100 d-center-start" v-if="item.value==='add_time'">
             <left-text :leftText="item.name"/><span >{{currentItem[item.value]| formatTimestamp(1)}}</span>
          </div>
          <div class="w-100 d-center-start" v-if="item.value!='add_time'&&item.value!='store_type'&&item.value!='fact_payment_pay'&&item.value!='charge'&&item.value!='payment_pay'">
             <left-text :leftText="item.name"/><span :class="item.color?item.color:''" v-html="currentItem[item.value]"></span>
          </div>
        </div>
      </div>
        <div slot="footer" class="dialog-footer">
            <!-- <el-button @click="dialogDLiest = false">关闭</el-button> -->
            <el-button type="primary" @click="dialogDLiest = false">确 定</el-button>
        </div>
    </el-dialog>
    <el-dialog title="修改信息" :visible.sync="receipt" width="20%" class="paymentist" :close-on-click-modal="false">
      <FlinReceipt :currentItem="receiptInfo" @finance="receipt=false" @financeList="receipt=false;getDataLists()"></FlinReceipt>
    </el-dialog>
  </div>
</template>

<script>
  import { mapGetters, mapActions,mapState } from 'vuex'
  import Receipt from './FinancialStats/Receipt.vue'
  import FlinReceipt from './Subassembly/FlinReceipt.vue'
  import { toUpper } from 'lodash';
  export default {
    name: 'PaymentRecordList',
    components: { Receipt,FlinReceipt},
    computed: {
      ...mapState(['AdminDataLists','userLoginMessage']),
      ...mapGetters(['storeInfo']),
      queryCon() { return this.$route.query },
      //搜索条件-开始时间
      startTime() { return this.timestamp ? this.timestamp[0] / 1000 : ''; },
      //搜索条件-结束时间
      endTime() { return this.timestamp ? this.timestamp[1] / 1000 + 86399 : ''; },
      titleArr() {
        let arr = ['打款ID','订单ID','门店类型','开户银行','银行卡号','企业/个人名称','打款金额(元)','手续费(元)','实际打款金额(元)',' 打款人','打款时间','状态','操作'];
        for(let i in arr){
          arr[i]=arr[i].replace(/\n/g, '<br/>')
        }
        return arr;
      },
      timeChoose() {
        let arr =  [
          {name:`按打款时间段`,value:'timeFrame'},
          {name:`按打款日期`,value:'timeArr'},
        ];
        return arr
      },
    },
    created() { 
      // 读取本地缓存
      const cache = JSON.parse(localStorage.getItem('paymentRecordSearchCache') || '{}');
      // 有缓存就回填表单
       if (this.$route.query) this.Formdata.page = Number(this.$route.query.page||1);
      if (cache.num) this.Formdata.num = Number(cache.num);
      this.getDataLists(); 
    },
    data() {
      return {
        dialogDLiest:false,
        receipt:false,
        receiptInfo:{},
        dialogFormVisible:false,
        formLabelWidth: '120px',
        showDetailArr:[
          {name:'打款ID',value:'pay_id'},{name:'回单号',value:'receipt_no'},{name:'订单ID',value:'oid'},
          {name:'门店类型',value:'store_type'},{name:'开户银行',value:'bank_name'},{name:'门店ID',value:'store_id'},
          {name:'银行卡号',value:'bank_card'},{name:'打款金额',value:'payment_pay'},{name:'企业/个人名称',value:'truename'},{name:'手续费',value:'charge'},
          {name:'打款人',value:'handle_name'},{name:'实际打款金额',value:'fact_payment_pay',color:'red'},{name:'打款时间',value:'add_time'},{name:'备注',value:'remark',color:'blues'},{name:'收款门店',value:'title'}

        ],
        fundsForm:[ 
          {name:'打款ID',prop:'pay_id',center:true,width:180},
          {name:'订单ID',prop:'oid',width:150,center:true,pattern:'oid'},
          {name:'门店名称',prop:'title',minWidth:200},
          {name:'银行账户',prop:'truename',minWidth:200},
          {name:'平台收款(元)',prop:'price_pay',center:true,width:150,pattern:'money'},
          {name:'手续费(元)',prop:'app_charge',center:true,width:150,pattern:'money',total:'charge_total'},
          {name:'付自由行(元)',prop:'offset_price_pay',center:true,width:150,pattern:'money'},
          {name:'订单金额(元)',prop:'payment_pay',center:true,width:150,pattern:'money'},
          {name:'酒店佣金(元)',prop:'charge',center:true,width:150,pattern:'money'},
          {name:'实际已付款金额(元)',prop:'fact_payment_pay',center:true,width:150,pattern:'money',total:'fact_payment_pay_total'},
          {name:'打款人',prop:'handle_name',center:true,width:120},
          {name:'打款时间',prop:'handle_time',center:true,width:180,pattern:'time'},
          {name:'状态',prop:'status',center:true,width:120,pattern:'status'},
        ],
        truename:'',
        timeType:'timeFrame',
        timestamp: [],
        hotel_title:'',
        showDetail:false,
        currentItem:{},     
        out_trade_no:'',
        is_merge:false,
        Formdata:{
            num:10,                                //每页显示条数
            page:1,                               //当前页

        },
        searchData:{
            title:'',                               //门店名称
            truename:'',                            //企业/个人名称
            oid:'',                               //订单ID
            store_type:0,                         //门店类型
            store_id:'',                          //门店ID
            bank_card:'',                         //银行卡号
            add_time:'',                           //按时间
            handle_time:''                        //按打款时间
        },
        timetime:'',
      }
    },
    methods:{
      ...mapActions(['getAdminDataLists','adminSetInvoice','adminPayment','adminPaymentInfor','POST_Admin_DownloadForm']),
      //确认搜索
        confirmSearch(){
          this.Formdata.page=1;
          this.getDataLists();
      },
      //底部合计
      getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
              if (index === 0) {
                sums[index] = '小计';
                return;
              }
              const excludeFields = ['add_time', 'status', 'store_type', 'handle_time', 'oid', 'add_time','bank_card'];
              const values = data.map(item => Number(item[column.property]));
              if (!values.every(isNaN) && !excludeFields.includes(column.property)) {
                sums[index] = values.reduce((prev, curr) => {
                  const value = Number(curr);
                  if (!isNaN(value)) {
                    return prev + curr;
                  } else {
                    return prev;
                  }
                }, 0);
                sums[index] = (sums[index]/100).toFixed(2);
              } else {
                sums[index] = '';
              }
            });
            return sums;
      },
      //设置分页数量
      handleSizeChange(val) {
        this.Formdata.num = val;
        this.Formdata.page=1;
        this.updateQuery({ num: val,page:1})
        this.getDataLists();
      },
      //设置当前页
      handleCurrentChange(val) {
        // 把参数存进路由地址栏，页面不动
        this.Formdata.page = val;
        this.updateQuery({ page: val });
        this.getDataLists();
      },
      // 统一更新路由方法
      updateQuery(query) {
        this.$router.replace({
          query: { ...this.$route.query, ...query }
        });
        // 2. 存入本地存储
        let cache = JSON.parse(localStorage.getItem('paymentRecordSearchCache') || '{}')
        localStorage.setItem('paymentRecordSearchCache', JSON.stringify({ ...cache, ...query }))
      },
        //订单详情页
        goHotelDetail (e) {
            let cardItem=e;
            console.log(this.storeInfo)
            let routeUrl = this.$router.resolve({
                name: 'OrderDetail',
                query: {
                    orderType: 3,
                    orderId: cardItem.oid,
                    storeId: this.storeInfo.type == 2 ? cardItem.main_id : (cardItem.store_id || cardItem.appoint),
                    status: cardItem.status,
                }
            });
            window.open(routeUrl.href, '_blank');
      },
      //点击操作按钮
      handleCommand(command,Itemize) {
        let htis = this;
        switch (command) {
          case '1':
            this.adminPaymentInfor({
                data:{pay_id:Itemize.pay_id},
                successFun: (res) => {
                    console.log(res);
                    htis.currentItem=res;
                    htis.dialogDLiest=true;
                }
            })
            break
          case '2':
            this.receiptInfo=Itemize;
            this.dialogFormVisible=true
            break
          case '3':
            this.receiptInfo=Itemize;
            console.log(this.receiptInfo);
            this.receipt=true
          break
        }
      },
    submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.adminPayment({
                data:this.ruleForm,
                successFun: () => {
                    this.getDataLists();
                    this._alert('提交成功');
                    this.dialogFormVisible = false;
                }
            }); 
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      //获取搜索表单
      getSearchForm() {
        let data={
          ...this.Formdata,
          ...this.searchData,
        };
        let start = this.timestamp && this.timestamp.length > 0 ? this.timestamp[0] / 1000 : '';
        let end = this.timestamp && this.timestamp.length > 0 ? this.timestamp[1] / 1000 + 86399 : '';
        switch (this.timeType) {
          case 'timeArr':
           let timeArr = this.timetime?this.timetime.getTime() / 1000:'';
            data.add_time = timeArr;
            break;
          case 'timeFrame':
            data.add_time = start?start+','+end:'';
            break;
        }
        return data;
      },
      //获取交易记录列表
      async getDataLists() {

         await this.getAdminDataLists({
            data:this.getSearchForm(),
            type:'PaymentRecordList',
        });
        // this.totalPayMoney = resInfo.total_pay_money || 0;
        // this.totalEndMoney = resInfo.total_end_money || 0;
      },
      //已付款下载表单
      loadTable(){
        this.POST_Admin_DownloadForm({data:this.getSearchForm(),type:2});
      },
    }
  }
</script>
<style lang="css" scoped>
   .pointers:hover{
    color: var(--smtc-color-primary); 
  }
  .refund_fee{
    font-size: 13px;
    margin-top: 2px;
    color:brown;
  }
  .list-item-col{
    white-space: pre-line;
  }
  .name{
      text-align: left;
  }
  .bottom{
    display: block;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .cops-text{
    opacity: 0;
  }
  .goHotelDetail{
    cursor: pointer;

  }
 .goHotelDetail:hover{
    color: var(--smtc-color-primary); 
  }
  .blues{
    color: #1d1dcc;
  }
  .totals{
    display: flex;

  } 
  .totals p{
      border-left: 1px #eee solid;
      padding: 0 10px;
      color: #666;
  }
  .totals p:nth-child(1),
  .totals p:nth-child(2) {
    border-left: none;
    padding-left: 0;
  }
  .price_pay{
    font-size: 12px;
    color: var(--smtc-color-primary);
  }
  .loadTable{
    margin-left: auto;
  }
</style>
<style>
.paymentist .el-form--label-top .el-form-item__label{
    display: block;
}
.bottom .el-button--mini{
  padding: 0;
}
.el-tables .el-dropdown{
  width: 100%;
}
</style>